import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import "./Forms.css";
import IntakeFormService from "../../services/intakeFormService";
import {
  BsFillPatchCheckFill,
  BsFillUnlockFill,
  BsFillLockFill,
} from "react-icons/bs";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import GIFormsImage from "../../images/GIForms.png";
import MHFormsImage from "../../images/MHForms.png";
import SAFormsImage from "../../images/SAForms.png";
import CFormsImage from "../../images/CForms.png";
import IFFormsImage from "../../images/IFForms.png";
import COVIDFormsImage from "../../images/COVIDForms.png";
import { useParams } from "react-router-dom";

const Forms = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const [data, setData] = useState([]);
  const [client, setClient] = useState("");
  const intakeFormService = new IntakeFormService();
  const [selectedId, setSelectedId] = useState("");
  const [intakeForms, setIntakeForms] = useState([]);
  const formatTime = (time) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(time).toLocaleDateString("en-US", options);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          setFormLoading(true);
          const formsData = await intakeFormService.getIntakeFormByClientId(id);
          setData(formsData.data);
          setFormLoading(false);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setFormLoading(false);
      }
    };
  
    fetchData();
  }, [id]);
  
  const handleRectangleClick = (url) => {
    window.open(url, "_blank");
  };

  const handleDropdownItemClick = (id) => {
    setSelectedId(id);
    const newURL = `/${id}`;
    navigate(newURL);
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "Open":
        return "open";
      case "Closed":
        return "closed";
      case "Submitted":
        return "submitted";
      case "Incomplete":
        return "incomplete";
      case "Approved":
        return "submitted";
      case "Rejected":
        return "closed";
      default:
        return "";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Open":
        return <BsFillUnlockFill className="status-icon open" />;
      case "Closed":
        return <BsFillLockFill className="status-icon closed" />;
      case "Submitted":
        return <BsFillPatchCheckFill className="status-icon submitted" />;
      case "Incomplete":
        return (
          <AiOutlineExclamationCircle className="status-icon inComplete" />
        );
      default:
        return null;
    }
  };

  const getImageByType = (type) => {
    switch (type) {
      case "GIForms":
        return GIFormsImage;
      case "MHForms":
        return MHFormsImage;
      case "SAForms":
        return SAFormsImage;
      case "CForms":
        return CFormsImage;
      case "IFForms":
        return IFFormsImage;
      case "COVIDForms":
        return COVIDFormsImage;
      default:
        return CFormsImage;
    }
  };

  return (
    <div className="page-wrapper">
          <div className="container col-md-12">
            <h3 className="form-headings">Forms</h3>
            {formLoading ? (
              <Spin
              size="large"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            ) : (
              <Row className="form-rows">
                {data?.length > 0 ? (
                  data?.map((box) => (
                    <Col xl={4} lg={6} md={12} sm={12} xs={12} key={box.formId}>
                      <div
                        className="rectangle mr-1"
                        onClick={() =>
                          box.adminStatus === "Approved" ||
                          box.FormStatus === "Submitted"
                            ? handleRectangleClick(box.AdminLink)
                            : handleRectangleClick(box.url)
                        }
                      >
                        <div className="image">
                          <img
                            src={getImageByType(box.type)}
                            alt={box.formName}
                            width={80}
                          />
                        </div>
                        <div className="content">
                          <div className="label">{box.formName}</div>
                          <div>{formatTime(box.createdAt)}</div>
                          <div>Status: {box.FormStatus}</div>
                        </div>
                        <div className="icon badge-container">
                          {box.FormStatus === "Open" && (
                            <span className="badge text-bg-primary">Open</span>
                          )}
                          {box.FormStatus === "Submitted" && (
                            <span className="badge text-bg-success">
                              Submitted
                            </span>
                          )}
                          {box.FormStatus === "Incomplete" && (
                            <span className="badge text-bg-warning">
                              Incomplete
                            </span>
                          )}
                          {box.FormStatus === "Closed" && (
                            <span className="badge text-bg-danger">Closed</span>
                          )}
                          {box.FormStatus === "Approved" && (
                            <span className="badge text-bg-success">
                              Approved
                            </span>
                          )}
                          {box.FormStatus === "Rejected" && (
                            <span className="badge text-bg-danger">
                              Rejected
                            </span>
                          )}
                        </div>
                        <div
                          className={`inner-rectangle ${getStatusClassName(
                            box.FormStatus
                          )}`}
                        ></div>
                      </div>
                    </Col>
                  ))
                ) : (
                  <h5 className="text-center">No open forms</h5>
                )}
              </Row>
            )}
          </div>
    </div>
  );
};

export default Forms;

